'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/BackOffice'

import DataList from '@/DataList'

import config from '@Config/Tutorial/tutorial'

const { app } = window;

export default class TutorialsDashboardPage extends Component
{
	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		var output =
		(
			<Layout history={ props.history } page_title="Tutoriels">

				<div className="page-content">

					<div className="o-content">
						<DataList config={ config } history={ props.history } />
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}
